import React, { useState } from "react";
import { RiDashboardFill } from "react-icons/ri";
import { AiOutlineClose, AiOutlineMenu } from "react-icons/ai";
import { FaRegCircleUser } from "react-icons/fa6";
import { Button, Layout, Menu, theme } from "antd";
import { useSelector } from "react-redux";
import { Link, useNavigate, Outlet } from "react-router-dom";
import { MdLocalActivity } from "react-icons/md";
import { TbReportAnalytics } from "react-icons/tb";
import Cookies from "js-cookie";
import scrollTop from "../helpers/scrollTop";
const { Header, Content, Sider } = Layout;
const AdminPanel = () => {
  const user = useSelector((state) => state?.user?.user);
  const navigate = useNavigate();
  const { token } = theme.useToken();
  const [isSidebarVisible, setIsSidebarVisible] = useState(true);
  const handleMenuClick = (key) => {
    navigate(key);
  };
  const handleLogout = () => {
    Cookies.remove("admin_id");
    navigate("/admin-login");
  };
  const toggleSidebar = () => {
    setIsSidebarVisible(!isSidebarVisible);
  };
  const menuItems = [
    { key: "dashboard", icon: <RiDashboardFill />, label: "Dashboard" },
    { key: "all-events", icon: <MdLocalActivity />, label: "Events" },
    {
      key: "contact-report",
      icon: <TbReportAnalytics />,
      label: "Contact Report",
    },
    {
      key: "admission-report",
      icon: <TbReportAnalytics />,
      label: "Admission Report",
    },
    { key: "newspanel", icon: <TbReportAnalytics />, label: "News Panel" },
  ];
  return (
    <Layout style={{ minHeight: "100vh" }}>
      {/* Sidebar */}
      <Sider
        width={250}
        style={{
          background: "#001529",
          position: "fixed",
          height: "100vh",
          left: 0,
          top: 0,
          bottom: 0,
          zIndex: 1000,
          transition: "transform 0.3s ease",
          transform: isSidebarVisible ? "translateX(0)" : "translateX(-100%)",
        }}
      >
        {/* Close Button */}
        <Button
          type="text"
          onClick={toggleSidebar}
          style={{
            fontSize: "20px",
            color: "white",
            background: "transparent",
            border: "none",
            position: "absolute",
            top: "16px",
            right: "10px",
          }}
        >
          <AiOutlineClose />
        </Button>
        {/* Admin Profile */}
        <a href="/admin-panel/dashboard">
          <div className="flex flex-col items-center p-4 mt-[30%]">
            <div className="text-3xl cursor-pointer">
              {user?.profilePic ? (
                <img
                  src={user?.profilePic}
                  className="w-12 h-12 rounded-full"
                  alt={user?.name}
                />
              ) : (
                <FaRegCircleUser className="text-white text-2xl" />
              )}
            </div>
            <p className="capitalize text-sm font-semibold text-white mt-2">
              ADMIN
            </p>
          </div>
        </a>

        {/* Menu Items */}
        <Menu
          theme="dark"
          mode="inline"
          defaultSelectedKeys={[]}
          onClick={({ key }) => handleMenuClick(key)}
          items={menuItems.map((item) => ({
            key: item.key,
            icon: item.icon,
            label: (
              <Link
                to={item.key}
                onClick={scrollTop}
                style={{ display: "block", textAlign: "left" }}
              >
                {item.label}
              </Link>
            ),
          }))}
        />
      </Sider>
      {/* Main Content */}
      <Layout
        style={{
          marginLeft: isSidebarVisible ? 250 : 0,
          transition: "margin-left 0.3s ease",
        }}
      >
        {/* Header */}
        <Header
          className="site-layout-background"
          style={{
            padding: "0 16px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            background: "#001529",
            position: "sticky",
            top: 0,
            zIndex: 999,
            height: "64px",
          }}
        >
          {/* Menu Icon when Sidebar is Closed */}
          {!isSidebarVisible && (
            <Button
              type="text"
              onClick={toggleSidebar}
              style={{
                fontSize: "24px",
                color: "white",
                background: "transparent",
                border: "none",
                position: "absolute",
                left: "16px",
                top: "16px",
              }}
            >
              <AiOutlineMenu />
            </Button>
          )}
          <h1 style={{ color: "white", textAlign: "center", margin: 0 }}>
            Admin Panel
          </h1>
          {/* Logout Button */}
          <div style={{ position: "absolute", top: "2%", right: "20px" }}>
            <Button
              type="text"
              onClick={handleLogout}
              style={{
                backgroundColor: "#DC2626",
                color: "white",
                border: "none",
                padding: "8px 16px",
                borderRadius: "4px",
                cursor: "pointer",
                transition: "background-color 0.3s",
              }}
              onMouseOver={(e) =>
                (e.currentTarget.style.backgroundColor = "#B91C1C")
              }
              onMouseOut={(e) =>
                (e.currentTarget.style.backgroundColor = "#DC2626")
              }
            >
              Logout
            </Button>
          </div>
        </Header>

        {/* Content */}
        <Content
          style={{
            margin: "20px 16px",
            padding: 24,
            minHeight: 280,
            background: token.colorBgContainer,
            borderRadius: token.borderRadiusLG,
          }}
        >
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  );
};
export default AdminPanel;
